const regions = [
	{
		path: '/community/wikigamer/regions/list',
		name: 'community-wikigamer-regions-list',
		component: () => import('@/views/community/wikigamer/regions/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGC,wikigamer',
		},
	},
]

export default regions
